// import { resolvePath } from "react-router-dom";
import { toBase64 } from "./file";
// import _ from "lodash";

/**
 * Se possível, converte o parâmetro em um objeto Image.
 */
export async function toImage(source) {
    if (source instanceof Image) {
        return source;
    } else {
        const image = new Image();
        image.crossOrigin = "anonymous"; // Para evitar problemas de CORS

        if (source instanceof File) {
            try {
                image.src = await toBase64(source);
            } catch (error) {
                console.error("Erro ao converter arquivo para base64:", error);
                throw new Error("Falha ao processar arquivo de imagem");
            }
        } else if (typeof source === 'string') {
            // Validação básica de URL/base64
            if (source.startsWith('data:image/') || source.startsWith('http') || source.startsWith('blob:')) {
                image.src = source;
            } else {
                throw new Error("Formato de imagem não suportado");
            }
        } else {
            throw new Error("Tipo de fonte de imagem inválido");
        }

        return image;
    }
}

/**
 * Redimensiona tamanho da imagem, mantendo proporções.
 */
export async function scaleImage(source, maxWidth, maxHeight, format = "image/jpeg", quality = 0.7) {
    return new Promise(async (resolve, reject) => {
        try {
            const canvas = document.createElement("canvas");
            const image = await toImage(source);
            
            image.onload = () => {
                try {
                    let width = image.width;
                    let height = image.height;

                    if (width > height) {
                        if (width > maxWidth) {
                            height = Math.round((height * maxWidth) / width);
                            width = maxWidth;
                        }
                    } else {
                        if (height > maxHeight) {
                            width = Math.round((width * maxHeight) / height);
                            height = maxHeight;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;

                    const context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, width, height);

                    const result = canvas.toDataURL(format, quality);
                    resolve(result);
                } catch (error) {
                    console.error("Erro ao processar imagem no canvas:", error);
                    reject(error);
                }
            };
            
            image.onerror = (error) => {
                console.error("Erro ao carregar imagem:", error);
                reject(new Error("Falha ao carregar a imagem"));
            };
            
        } catch (error) {
            console.error("Erro geral na função scaleImage:", error);
            reject(error);
        }
    });
}

/**
 * Rotaciona imagem. Suporta apenas rotações múltiplas de 90°.
 */
export async function rotateImage(source, degrees, format = "image/jpeg", quality = 0.7) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    const image = await toImage(source);

    if (degrees % 180 === 0) {
        canvas.width = image.width;
        canvas.height = image.height;
    } else if (degrees % 90 === 0) {
        canvas.width = image.height;
        canvas.height = image.width;
    } else {
        throw new Error("Ângulo de rotação da imagem deve ser múltiplo de 90°.");
    }

    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate((degrees * Math.PI) / 180);
    context.drawImage(image, -image.width / 2, -image.height / 2);

    return canvas.toDataURL(format, quality);
}
